<template>
  <div
    role="menu"
    @keyup.enter="isExpanded = !isExpanded"
  >
    <div
      v-click-outside="collapseDropdown"
      class="account-dropdown-menu"
    >
      <AccountSvg
        class="account-svg"
        @click="toggleDropdown"
      />
      <div
        v-show="isExpanded"
        class="account-dropdown-menu-options-container"
      >
        <router-link
          to="/my-account"
          class="account-dropdown-menu-option my-account"
          @click="collapseDropdown"
        >
          My Account
        </router-link>
        <router-link
          to="/change-password"
          class="account-dropdown-menu-option change-password"
          @click="collapseDropdown"
        >
          Change Password
        </router-link>
        <div
          class="account-dropdown-menu-option logout"
          :tabindex="0"
          @click="logout()"
          @blur="isExpanded = false"
        >
          Logout
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import AccountSvg from '@/components/svgs/AccountSvg.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'

export default defineComponent({
  name: 'AccountDropdownMenu',
  components: {
    AccountSvg
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    collapseDropdown(): void {
      this.isExpanded = false
    },
    logout(): void {
      this.miscellaneousService.logoutUser().then(() => {
        this.collapseDropdown()
        this.$router.push('/')
      })
    },
    toggleDropdown(): void {
      this.isExpanded = !this.isExpanded
    }
  }
})
</script>

<style scoped lang="scss">

.account-dropdown-menu {
  position: relative;

  > .account-svg {
    cursor: pointer;
    color: $Color-font-high;
  }

  > .account-dropdown-menu-options-container {
    position: absolute;
    right: 0;
    min-width: 170px;
    background: $Color-white;
    border: 1px solid $Color-fill-black;
    @include element-shadow;

    > .account-dropdown-menu-option {
      display: block;
      text-align: right;
      color: $Color-font-high;
      font-size: 18px;
      text-decoration: none;
      padding: 16px;
      cursor: pointer;

      &:hover {
        color: $Color-sac-orange;
      }

      &.my-account {
        padding-bottom: 8px;
      }

      &.change-password {
        padding-top: 8px;
        padding-bottom: 8px;
      }

      &.logout {
        padding-top: 8px;
      }
    }
  }
}

</style>
